import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Collapse,
  Drawer,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterListTwoTone";
import MainCard from "../../../components/Maincard";
import ApplyFilterButton from "../../newComponent/NewButtonComp/ApplyFilterButton";
import ClearButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import ResetFilterButton from "../../newComponent/NewButtonComp/ResetFilterButton";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { useGetTokenOrLogout } from "../../../utils/token";
export default function PackagesFilter({
  open,
  packageData,
  searchData,
  originalData,
  setPackages,
  setSearchData,
  showSnackbar,
  serviceId,
  setIsLoading,
}) {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const userId = localStorage.getItem("userId");
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const getTokenOrLogout = useGetTokenOrLogout();
  const [testtypelist, setTesttypeList] = useState([]);
  const [testtype, setTesttype] = useState([]);
  const [subTestTypeList, setSubtestTypeList] = useState([]);
  const [subtestType, setsubtestType] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [packageName, setPackageName] = useState("");
  const [status, setstatus] = useState([]);
  const [duration, setduration] = useState("");
  const [subServiceList, setSubServiceList] = useState([]);
  const [subservice, setSubService] = useState([]);
  const [subserviceIds, setSubserviceIds] = useState([]);
  const [programList, setProgramList] = useState([]);
  const [programName, setProgramName] = useState([]);
  const [allUserList, setAlluserList] = useState([]);
  const [userName, setUserName] = useState([]);
   const [countryList, setCountryList] =useState([])
    const [countryName, setCountryName] =useState([])

  const handleNamechange = (e) => {
    setPackageName(e.target.value);
  };

  const handledurationchange = (e) => {
    setduration(e.target.value);
    console.log(e.target.value);
  };

  // Sub Service
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();

          const subserviceData = data.filter((i) => serviceId === i.service_id);
          setSubServiceList(subserviceData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [serviceId]);

  const allSubservices = [{ name: "Select All" }, ...subServiceList];

  const handleSubserviceChange = (e, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setSubService(subServiceList);
      setSubserviceIds(subServiceList?.map((i) => i.id));
    } else {
      setSubService(value);
      setSubserviceIds(value?.map((i) => i.id));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice-program`);
        if (response.ok) {
          const data = await response.json();
          if(subservice?.length>0) { 
          const filterddata = data.filter((i)=>subserviceIds.includes (i.sub_service_id))
          setProgramList(filterddata);
          }
          else{
            setProgramList(data);
          }
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [subserviceIds]);

  const allProgramList = [{ name: "Select All" }, ...programList];

  const handleprogramChange = (e, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setProgramName(programList);
    } else {
      setProgramName(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalltesttype`);
        if (response.ok) {
          const data = await response.json();

          setTesttypeList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allTestTypes = [{ name: "Select All" }, ...testtypelist];
  const handeltestTypechange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setTesttype(testtypelist);
    } else {
      setTesttype(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subtesttype`);
        if (response.ok) {
          const data = await response.json();

          setSubtestTypeList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allSubTestTypes = [{ name: "Select All" }, ...subTestTypeList];
  const handelSubtestTypechange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setsubtestType(subTestTypeList);
    } else {
      setsubtestType(value);
    }
  };

  useEffect(() => {
      // Fetch menu items using the fetch function
      fetch(`${API_ENDPOINT}country`)
        .then((response) => response.json())
        .then((data) => {
          const filteredcountry=data.filter((i)=>i.country_name==="India" || i.country_name==="Nepal" )
          setCountryList(filteredcountry);
       
        })
        .catch((error) => {
          console.error("Error fetching testtypes:", error);
        });
    }, []);

    const handleCountryChange=(e,value)=>{
 if (value.some((option) => option.country_name === "Select All")) {
      setCountryName(countryList);
    } else {
      setCountryName(value);
    }
    }

      const allCountryList= [{ country_name: "Select All" }, ...countryList];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();

          setBranchlist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allbranchList = [{ branch_name: "Select All" }, ...branchlist];

  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalluser`);
        if (response.ok) {
          const data = await response.json();

          setAlluserList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allUsersList = [{ first_name: "Select All" }, ...allUserList];

  const handeluserchange = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setUserName(allUserList);
    } else {
      setUserName(value);
    }
  };

  const statuslist = [
    {
      id: 1,
      name: "Active",
      value: "active",
    },
    {
      id: 2,
      name: "Inactive",
      value: "inActive",
    },
  ];

  const handlestatuschange = (event, value) => {
    setstatus(value);
  };

  const newBranch = branch.map((i) => i.branch_name);
  const newTestType = testtype.map((i) => i.id);
  const newStatus = status.map((i) => i.value);

  const resetfilter = () => {
    // onResetFilter();
    setPackageName("");
    setduration("");
    setTesttype([]);
    setBranch([]);
    setstatus([]);
  };

  // const handleApplyFilter = () => {
  //   onApplyFilter({
  //     packageName,
  //     duration,
  //     newTestType,
  //     newBranch,
  //     newStatus,
  //   });
  // };

  const handleApplyFilter = async (event) => {
    setIsLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const requestData = {
      user_id: parseInt(userId),
      test_type_id: testtype.map((i) => i.id),
      sub_service_id: subservice.map((i) => i.id),
      scholars_program_id: programName.map((i) => i.id),
      branch_id: branch.map((i) => i.id),
      status: status.map((i) => i.value),
      sub_test_type_id: subtestType.map((i) => i.id),
      created_by: userName.map((i) => i.id),
      service_id: [serviceId],
      country_id:countryName.map((i)=>i.id)
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}package/filter/filterpackages`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setPackages(result);
        setSearchData(result);
        setIsLoading(false);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setIsLoading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setIsLoading(false);
      } else {
        showSnackbar("Internal server error", "error");
        setIsLoading(false);
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
      setIsLoading(false);
    }
  };

  const handleResetFilter = () => {
    setBranch([]);
    setTesttype([]);
    setSubService([]);
    setPackages(originalData);
    setSearchData(originalData);
    setstatus([]);
    setsubtestType([]);
    setUserName([]);
    setstatus([]);
    setProgramName([]);
    setCountryName([])
  };

  return (
    <>
      <Collapse in={open}>
        <MainCard>
          <Grid container spacing={2}>
            {/* <Grid item xs={6} lg={3} sm={4} md={4}>
              <Typography variant="h6">Package name</Typography>

              <CustomTextFieldComp
                size="normal"
                value={packageName}
                onChange={handleNamechange}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                fullWidth
              />
            </Grid> */}

            <Grid item xs={6} lg={3} sm={4} md={4}>
              <Typography variant="h6">Sub Service</Typography>
              <CustomAutocompleteComp
                disablePortal
                multiple
                value={subservice}
                size="small"
                onChange={handleSubserviceChange}
                options={allSubservices}
                getOptionLabel={(option) => option.name}
                tooltipContent={(option) => option.name}
              />
            </Grid>

            {serviceId === 2 && (
              <Grid item xs={12} lg={3}>
                <Typography variant="h6">Program</Typography>

                <CustomAutocompleteComp
                  size="small"
                  value={programName}
                  multiple
                  onChange={handleprogramChange}
                  options={allProgramList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        style: { borderRadius: "10px" }, // Add borderRadius here
                      }}
                    />
                  )}
                />
              </Grid>
            )}

            {/* <Grid item xs={6} lg={3} sm={4} md={4}>
              <Typography variant="h6">Duration (in session)</Typography>

              <CustomTextFieldComp
                size="normal"
                value={duration}
                onChange={handledurationchange}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                fullWidth
                type="number"
              />
            </Grid> */}

            {serviceId === 1 && (
              <>
                <Grid item xs={12} lg={3}>
                  <Typography variant="h6">Test Type </Typography>

                  <CustomAutocompleteComp
                    value={testtype}
                    multiple
                    onChange={handeltestTypechange}
                    options={allTestTypes}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          style: { borderRadius: "10px" }, // Add borderRadius here
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <Typography variant="h6">Sub Test Type </Typography>

                  <CustomAutocompleteComp
                    value={subtestType}
                    multiple
                    onChange={handelSubtestTypechange}
                    options={allSubTestTypes}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          style: { borderRadius: "10px" }, // Add borderRadius here
                        }}
                      />
                    )}
                  />
                </Grid>

               
              </>
            )}

            
    <Grid item xs={12} lg={3} md={6} sm={6}>
         
              <Typography variant="h6">Country </Typography>
             
              
                  <CustomAutocompleteComp
                     fullWidth
                    size="small"
                    multiple
                 disableClearable
                    value={countryName}
                    onChange={handleCountryChange}
                    options={allCountryList}
                    getOptionLabel={(option) => option.country_name}
                    tooltipContent={(option) => option.country_name}
                    
                  />
              
        
          </Grid>

           <Grid item xs={12} lg={3} md={6} sm={6}>
                  <Typography variant="h6">Branch</Typography>

                  <CustomAutocompleteComp
                    size="small"
                    fullWidth
                    value={branch}
                    multiple
                    onChange={handelbranchchange}
                    options={allbranchList}
                    getOptionLabel={(option) => option.branch_name}
                    tooltipContent={(option) => option.branch_name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          style: { borderRadius: "10px" }, // Add borderRadius here
                        }}
                      />
                    )}
                  />
                </Grid>

            <Grid item xs={12} lg={3}>
              <Typography variant="h6">Status</Typography>

              <CustomAutocompleteComp
                size="small"
                value={status}
                multiple
                onChange={handlestatuschange}
                options={statuslist}
                getOptionLabel={(option) => option.name}
                tooltipContent={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: "10px" }, // Add borderRadius here
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Typography variant="h6">Created By</Typography>

              <CustomAutocompleteComp
                value={userName}
                multiple
                onChange={handeluserchange}
                options={allUsersList}
                getOptionLabel={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
                tooltipContent={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: "10px" }, // Add borderRadius here
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} container gap={1} justifyContent="end">
              <ApplyFilterButton onClick={handleApplyFilter} />
              <ResetFilterButton onClick={handleResetFilter} />
            </Grid>
          </Grid>
        </MainCard>
      </Collapse>
    </>
  );
}
